/// <amd-module name="Build/Admin/PoolsList/Components/SecurityPanel" />
import * as React from "react";

import { IProjectData } from "Tfs/Platform/Page";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IVssPageService } from "VSS/Platform/Page";

import { ContentSize } from "VSSUI/Callout";
import { Panel } from "VSSUI/Panel";

import { PoolRoles, PoolRolesScope } from "Build/Admin/Common/Components/PoolRoles";
import { IProjectDataService } from "Build/Admin/Common/Services/ProjectDataService";
import { PoolsListActionCreator } from "Build/Admin/PoolsList/Actions/PoolsListActionCreator";
import { StoresHub } from "Build/Admin/PoolsList/Stores/StoresHub";

import * as Resources from "Build/Admin/PoolsList/Resources";

export interface ISecurityPanelProps {
    actionCreator: PoolsListActionCreator;
    storesHub: StoresHub;
}

interface ISecurityPanelState {
    isOpen: boolean;
}

export class SecurityPanel extends VssComponent<ISecurityPanelProps, ISecurityPanelState> {
    private _onPrem: boolean;
    private _project: IProjectData | undefined;

    constructor(props: ISecurityPanelProps, context: IVssComponentContext) {
        super(props, context);
        this.state = this._getStateFromStores();

        const vssPageService = context.pageContext.getService<IVssPageService>("IVssPageService");
        const projectDataService = context.pageContext.getService<IProjectDataService>("IProjectDataService");
        const vssPageData = vssPageService.getData();

        if (vssPageData) {
            this._onPrem = !vssPageData.isHosted;
        }

        this._project = projectDataService.getProjectData();
    }

    public componentDidMount(): void {
        this.props.storesHub.securityPanelStore.addChangedListener(this._onStoreChanged);
    }

    public componentWillUnmount(): void {
        this.props.storesHub.securityPanelStore.removeChangedListener(this._onStoreChanged);
    }

    public render(): JSX.Element | null {
        if (this.state.isOpen) {
            return (
                <Panel
                    className="pipelines-pools-security-panel"
                    size={ContentSize.Large}
                    titleProps={{ text: Resources.PoolsSecurityPanelTitle }}
                    description={this._getDescriptionText()}
                    onDismiss={this._cancelOnClick}>
                    <PoolRoles
                        selectedRolesScope={this._project ? PoolRolesScope.Queue : PoolRolesScope.Pool}
                        hasManagePermission={this.props.storesHub.securityStore.state.hasManageAllPermission} />
                </Panel>
            );
        }

        return null;
    }

    private _cancelOnClick = (): void => {
        this.props.actionCreator.dismissSecurityPanel();
    }

    private _onStoreChanged = (): void => {
        this.setState(this._getStateFromStores());
    }

    private _getDescriptionText = (): string => {
        if (this._project) {
            return Resources.ProjectPoolsSecurityPanelDescription;
        }
        else if (this._onPrem) {
            return Resources.OrgPoolsSecurityPanelDescriptionOnPrem;
        }
        else {
            return Resources.OrgPoolsSecurityPanelDescriptionHosted;
        }
    }

    private _getStateFromStores = (): ISecurityPanelState => {
        return {
            isOpen: this.props.storesHub.securityPanelStore.state.isOpen
        };
    }
}
